export const fr = {
  nav: {
    home: 'Accueil',
    for_companies: 'Pour les entreprises',
    for_nonprofits: 'Pour les associations',
    how_it_works: 'Comment ça marche',
    features: 'Fonctionnalités',
    stories: 'Témoignages',
    resources: 'Ressources',
    virtual_volunteering_tips: 'Conseils pour le bénévolat virtuel',
    case_studies: 'Études de cas',
    all_events: 'Activités de bénévolat',
    gallery: 'Galerie',
    my_events: 'Mes demandes et activités de bénévolat',
    volunteer_activity: 'Mon Bénévolat',
    all_requests: 'Toutes Les Demandes',
    impact: 'Impact',
    employees: 'Employés',
    help: 'Aide',
    company_settings: "Paramètres de l'entreprise",
    account_settings: 'Paramètres du compte',
    features_integrations: 'Intégrations',
    features_reporting: 'Rapports',
    features_nonprofit_network: 'Réseau d\'organismes à but non lucratif',
    features_shifts: "Gestion d'événements",
    log_in: 'Se connecter',
    log_out: 'Se déconnecter',
    greenshield: 'L’Expérience d’une GreenShield unifiée',
  },
}
